import { createFileRoute } from '@tanstack/react-router';

/**
 * Aba Investimentos — conteúdo idêntico ao antigo /portfolio. Componente vem de
 * portfolio.index.lazy.tsx (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/portfolio/')({});
